import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetDataFlowMetricsResData extends ApiGenericResponse {
    metrics: {};

    constructor(response: AxiosResponse) {
        super(response);
        this.metrics = new Map<string, {}>();
        if (response.data && response.data.Payload) this.metrics = response.data.Payload;
    }
}
